import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/categories';

export default function BlogPreview() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="mx-auto" style={{ maxWidth: 1200 }}>
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-12">
          <div className="lg:w-1/3">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
              GTBuy Sheet
              <br />
              <span className="text-foreground-400">Guides &amp; SEO Hub</span>
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-600 leading-relaxed max-w-lg">
              Stay informed with our regularly updated guides, comparisons, and deep dives into the world of GTBuy spreadsheet sourcing. New content published weekly to help you make smarter shopping decisions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article, idx) => (
            <Link
              key={article.seq}
              to={article.slug}
              className={`group block rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] ${
                idx === 0
                  ? 'bg-foreground-950 md:row-span-1'
                  : 'bg-background-100'
              }`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {article.isNew && (
                  <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-accent-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50"></span>
                    New
                  </div>
                )}
              </div>
              <div className="p-5">
                <span className={`inline-block text-xs font-medium px-2.5 py-1 rounded-full mb-3 ${
                  idx === 0
                    ? 'bg-background-50/10 text-background-50/80'
                    : 'bg-secondary-100 text-secondary-900'
                }`}>
                  {article.tag}
                </span>
                <h3 className={`font-heading text-lg md:text-xl font-semibold mb-2 leading-snug ${
                  idx === 0 ? 'text-background-50' : 'text-foreground-950'
                }`}>
                  {article.title}
                </h3>
                <p className={`text-sm mb-4 line-clamp-2 ${
                  idx === 0 ? 'text-background-50/50' : 'text-foreground-500'
                }`}>
                  {article.excerpt}
                </p>
                <div className={`flex items-center justify-between text-xs ${
                  idx === 0 ? 'text-background-50/50' : 'text-foreground-400'
                }`}>
                  <span>{article.readTime}</span>
                  <span className={`group-hover:translate-x-1 transition-transform whitespace-nowrap ${
                    idx === 0 ? 'text-background-50/70' : 'text-foreground-600'
                  }`}>
                    Read More →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}